import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UserServiceV2 } from '@app/v2/services/user-service/user.service';
import { CrcDashboardPageComponent } from '../../components/crc-dashboard/crc-dashboard.page.component';
import { MainDashboardPageComponent } from '../../components/main-dashboard/main-dashboard.page.component';

@Component({
    selector: 'medpace-dashboard.page',
    imports: [MainDashboardPageComponent, CrcDashboardPageComponent, AsyncPipe],
    templateUrl: './dashboard.page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardPageComponent {
    private readonly userService = inject(UserServiceV2);

    hasPermissionToMainDashboard$ = this.userService.hasAllPermissions$(['dashboard.main.page.view']);
    hasPermissionToCrcDashboard$ = this.userService.hasAllPermissions$(['dashboard.crc.page.view']);
}
